export const normalizeEmail = (email: string): string => email.trim().toLowerCase();
